import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93cd80c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "W-100",
  style: {"user-select":"none"}
}
const _hoisted_2 = {
  key: 0,
  class: "D-Flex F_85em",
  style: {"margin-bottom":"0.5em"}
}
const _hoisted_3 = { class: "M-Auto" }
const _hoisted_4 = {
  key: 1,
  class: "W-100 P-Rel D-Flex"
}
const _hoisted_5 = ["min", "max", "step"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "P-Abs Inset0",
  style: {"user-select":"none","pointer-events":"none","z-index":"2"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "CookiesSliderBG" }),
  /*#__PURE__*/_createElementVNode("div", { class: "CookiesSliderFill" })
], -1))
const _hoisted_7 = {
  class: "D-Flex F_75em",
  style: {"margin-top":"0.3em"}
}
const _hoisted_8 = { style: {"flex":"1","text-align":"start"} }
const _hoisted_9 = {
  class: "F-Bold",
  style: {"flex":"1"}
}
const _hoisted_10 = { style: {"flex":"1","text-align":"end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.SettingsHandler.Name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Translate(_ctx.SettingsHandler.Name)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.SettingsHandler)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$store.state.CookiesMemory[_ctx.SettingsHandler.Res]) = $event)),
            type: "range",
            min: _ctx.SettingsHandler.Min,
            max: _ctx.SettingsHandler.Max,
            step: _ctx.SettingsHandler.Steps,
            class: "CookiesSlider"
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.$store.state.CookiesMemory[_ctx.SettingsHandler.Res]]
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.DecimalFixer(_ctx.SettingsHandler.Min)), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.DecimalFixer(_ctx.MEMRead(_ctx.SettingsHandler.Res))), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.DecimalFixer(_ctx.SettingsHandler.Max)), 1)
    ])
  ]))
}